import { type ReactNode, useId } from "react";

import { cn } from "@/shared/lib";

type ProfileSectionProps = {
  title: ReactNode;
  // Подпись справа от заголовка.
  aside?: ReactNode;
  className?: string;
  children: ReactNode;
};

// Карточка блока профиля: заголовок, подпись и содержимое.
export const ProfileSection = ({ title, aside, className, children }: ProfileSectionProps) => {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className={cn(
        "flex min-w-0 flex-col gap-3.5 rounded-xl border border-border bg-surface p-5",
        className,
      )}
    >
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h2 id={headingId} className="font-display text-2xl">
          {title}
        </h2>
        {aside}
      </div>
      {children}
    </section>
  );
};
